import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function SidebarItem({ href, text, incomplete }) {
  const classes = classNames({
    current: window.location.pathname === href,
  });

  return (
    <li>
      <a href={href} className={classes}>
        {text}
        {incomplete && (
          <span className="incomplete-details-indicator" />
        )}
      </a>
    </li>
  );
}

SidebarItem.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  incomplete: PropTypes.bool,
};

SidebarItem.defaultProps = {
  incomplete: false,
};
